module.exports = __webpack_public_path__ + "static/city_icon_134-b0a06d5646444606c2948f42b6d024af.png";